// Application route paths.
// Web and mobile share the same routes; responsiveness is handled via CSS
// and the useBreakpoint hook, not separate mobile-only routes (see §4).
export const APP_BASENAME = process.env.REACT_APP_BASENAME || '/esmart-ui';

export const ROUTES = {
  login: '/login',
  analysis: '/analysis',
  indices: '/indices',
  summary: '/summary',
  performanceTrends: '/performance-trends',
  dividends: '/dividends',
  comparison: '/comparison',
  instructions: '/instructions',
  investmentIndicators: '/investment-indicators',
} as const;

export type RouteKey = keyof typeof ROUTES;

// Common iframe/query context accepted by every route.
export const PRESERVED_QUERY_PARAMS = [
  'ric',
  'ticker',
  'mkt',
  'tab',
  'locale',
  'theme',
  'token',
] as const;

export type PreservedQueryParam = (typeof PRESERVED_QUERY_PARAMS)[number];
